// Zweck: Gemeinsame Fotoerkennung für Artikel und Seriennummern. Stand: 21.10.2026.
import { BarcodeDetector, prepareZXingModule } from 'barcode-detector/ponyfill';

export async function readWarehouseCode(file: File): Promise<string> {
  await prepareZXingModule({
    overrides: {
      locateFile: (path: string) =>
        path.endsWith('.wasm') ? '/wasm/zxing_reader.wasm' : path,
    },
  });
  const image = await createImageBitmap(file);
  try {
    const results = await new BarcodeDetector({
      formats: [
        'qr_code',
        'code_128',
        'code_39',
        'ean_13',
        'ean_8',
        'data_matrix',
        'upc_a',
        'upc_e',
        'itf',
      ],
    }).detect(image);
    const codes = [...new Set(results.map((result) => result.rawValue))];
    if (!codes.length)
      throw new Error(
        'Code nicht erkannt. Erneut aufnehmen oder Artikel suchen.',
      );
    if (codes.length !== 1)
      throw new Error(
        'Mehrere Codes im Bild. Bitte nur das Etikett des gewünschten Artikels aufnehmen.',
      );
    return codes[0];
  } finally {
    image.close();
  }
}
